export const zoneLevels = [
  { label: 'Zone', value: 1 },
  { label: 'Section', value: 2 },
  { label: 'Block', value: 3 },
  { label: 'Pit', value: 4 },
]

export const priorityOptions = [
  { label: 'Low', value: 1 },
  { label: 'Medium', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
]

export const boardVisibilityOptions = [
  { label: 'Internal (team)', value: 1 },
  { label: 'Ops directors', value: 2 },
  { label: 'Executive', value: 3 },
]

export const horizonTypeOptions = [
  { label: 'Next Hours', value: 1 },
  { label: 'Next Shift', value: 2 },
]

export const planStatuses = [
  { label: 'Draft', value: 1, color: '#8A8A8A' },
  { label: 'Active', value: 2, color: '#24D07B' },
  { label: 'Paused', value: 3, color: '#F4D03F' },
  { label: 'Completed', value: 4, color: '#6B8A6B' },
  { label: 'Cancelled', value: 5, color: '#E74C3C' },
]

export const executableTypeList = [
  { value: 1, label: 'Cycle' },
  { value: 2, label: 'Workflow' },
  { value: 3, label: 'Process' },
]

export const advanceRuleList = [
  { value: 1, label: 'Manual Gate' },
  { value: 2, label: 'Auto on completion' },
]

export const horizonList = [
  { value: 1, label: 'Horizon 1' },
  { value: 2, label: 'Horizon2' },
  { value: 3, label: 'Horizon 3' },
]

export const planPriorities = [
  { label: 'Low', value: 1 },
  { label: 'Medium', value: 2 },
  { label: 'High', value: 3 },
  { label: 'Critical', value: 4 },
]

export const STATUS_COLORS: Record<string, string> = {
  Active: '#24D07B',
  Paused: '#F4D03F',
  Completed: '#6B8A6B',
  Cancelled: '#E74C3C',
  Draft: '#8A8A8A',
}

// Draft = 1, Active = 2, Completed = 3, Skipped = 4

export const phaseStatuses = [
  { label: 'Draft', value: 1, color: '#8A8A8A' },
  { label: 'Active', value: 2, color: '#24D07B' },
  { label: 'Completed', value: 3, color: '#6B8A6B' },
  { label: 'Skipped', value: 4, color: '#E74C3C' },
]

export const workflowCriteriaList = [
  { label: 'Cheapest', value: 1 },
  { label: 'Soonest', value: 2 },
]

export const planAuditEventTypes = [
  { label: 'Created', value: 1, color: '#8A8A8A' },
  { label: 'Updated', value: 2, color: '#5B8DEF' },
  { label: 'Activated', value: 3, color: '#24D07B' },
  { label: 'Paused', value: 4, color: '#F4D03F' },
  { label: 'Resumed', value: 5, color: '#24D07B' },
  { label: 'Completed', value: 6, color: '#6B8A6B' },
  { label: 'Cancelled', value: 7, color: '#E74C3C' },
]
